import React from 'react';
import styled from 'styled-components';
import Humanize from 'humanize-plus';
import { font, ChartCell, ChartCellWrapper } from './sharedStyles';
import { getColumnBorderFlags } from './columnBorderFlags';
import type { CellTextAlign } from '../cellAlignment';

const EDGE_PADDING = '12px';

const Text = styled('div')<{ $align: CellTextAlign }>`
  position: absolute;
  z-index: 2;
  top: 5px;
  left: 0px;
  text-align: ${({ $align }) => $align};
  letter-spacing: -0.3px;
  font-size: 13px;
  width: 100%;
  height: 100%;
  padding-left: ${({ $align }) => ($align === 'left' ? EDGE_PADDING : '0')};
  padding-right: ${({ $align }) => ($align === 'right' ? EDGE_PADDING : '0')};
  ${font}
`;

export const PercentRenderer =
  (
    firstColumnIds: Set<string>,
    lastColumnIds: Set<string>,
    columnIds: string[],
    hasScroll: boolean | undefined,
    textAlign: CellTextAlign = 'center',
  ) =>
  // eslint-disable-next-line react/display-name
  ({ cellData, columnIndex }: any) => {
    const { isFirst, isLast } = getColumnBorderFlags(columnIds, columnIndex, firstColumnIds, lastColumnIds, hasScroll);

    return (
      <ChartCell $isfirst={isFirst ? 1 : 0} $islast={isLast ? 1 : 0}>
        <ChartCellWrapper>
          <Text $align={textAlign}>
            {Number(isNaN(cellData)) ? '-' : `${Humanize.toFixed(cellData, 2).replace('.00', '')}%`}
          </Text>
        </ChartCellWrapper>
      </ChartCell>
    );
  };
